import { doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

const KEY = 'tott.zone';

/**
 * Notes this browser's time zone, once (and again if it changes), so the admins' stats can count
 * visitors by country. Only the zone, e.g. "Asia/Kolkata": never a location.
 */
export async function noteTimeZone(uid: string): Promise<void> {
  const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (!zone) return;
  const noted = `${uid}|${zone}`;
  try {
    if (localStorage.getItem(KEY) === noted) return;
  } catch {
    /* storage unavailable: note it anyway */
  }
  try {
    await setDoc(doc(db, 'visitors', uid), { tz: zone, at: serverTimestamp() });
    localStorage.setItem(KEY, noted);
  } catch {
    /* offline or storage unavailable: try again next visit */
  }
}
